<template>
    <div>
        <v-btn
            small
            flat
            to="/"
        >
            <span class="mr-0">{{homeNavTitle}}</span>
        </v-btn>
        <v-btn
            small
            flat
            to="/policy"
        >
            <span class="mr-0">{{privateDataPolicyNavTitle}}</span>
        </v-btn>
        <v-btn
            small
            flat
            to="/imprint"
        >
            <span class="mr-0">{{imprintNavTitle}}</span>
        </v-btn>
        <v-btn
            small
            flat
            to="/contact"
        >
            <span class="mr-0">{{contactNavTitle}}</span>
        </v-btn>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState('ContactModule', [ 
                                        'homeNavTitle',
                                        'privateDataPolicyNavTitle',
                                        'imprintNavTitle',
                                        'contactNavTitle',
                                        ]),
    },
}
</script>

